import React, {useEffect, useState} from 'react';
import {EMAILREGEX, PASSWORDREGEX} from "../../../interfaces/Helper";
import {Box} from "@chakra-ui/layout";
import Logo from "../../utilities/Logo";
import {Button, FormControl, FormErrorMessage, FormLabel, Input, Link} from "@chakra-ui/react";
import {NavLink, useHistory} from "react-router-dom";
import {StateType, useStudentAuthDispatch} from "../../../store/store";
import {teacherRegister} from "../../../action/teacherAction";
import {useSelector} from "react-redux";

function TeacherRegister() {
  const dispatch = useStudentAuthDispatch();
  const {data: {role}} = useSelector((state: StateType) => state.rootReducer.teacherReducer)
  let history = useHistory()
  // form values
  const [fullname, handleFullname] = useState<string>("");
  const [username, handleUsername] = useState<string>("");
  const [email, handleEmail] = useState<string>("");
  const [password, handlePassword] = useState<string>("");
  // errors
  const [errorUsername, handleErrorUsername] = useState<string>("");
  const [errorFullname, handleErrorFullname] = useState<string>("");
  const [errorEmail, handleErrorEmail] = useState<string>("");
  const [errorPassword, handleErrorPassword] = useState<string>("");
  // reveal password
  const [eyeStatus, handleEyeStatus] = useState<boolean>(true);

  function revealPassword() {
    handleEyeStatus(!eyeStatus);
  }

  function submitForm(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();
    // email checks
    if (email === "") {
      return handleErrorEmail("Please enter an email")
    }
    handleErrorEmail("")
    if (!EMAILREGEX.test(email)) {
      return handleErrorEmail("Please enter a valid email")
    }
    handleErrorEmail("");
    // fullname checks
    if (fullname === "") {
      return handleErrorFullname("Please enter your fullname");
    }
    handleErrorFullname("")
    if (fullname.length < 3 || fullname.length > 30) {
      return handleErrorFullname("Your fullname cannot be less than 3 or more than 30.")
    }
    handleErrorFullname("");
    // username checks
    if (username === "") {
      return handleErrorUsername("Please enter a username")
    }
    handleErrorUsername("")
    if (username.length < 3 || username.length > 15) {
      return handleErrorUsername("Please your username cannot be less than 3 or greater than 15")
    }
    handleErrorUsername("");
    // password checks
    if (password === "") {
      return handleErrorPassword("Please enter a password")
    }
    handleErrorPassword("")
    if (!PASSWORDREGEX.test(password)) {
      return handleErrorPassword("Password must be minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character");
    }
    handleErrorPassword("")
    console.log("submit button clicked");
    const teacherData = {username, password, fullname, email}
    dispatch(teacherRegister(teacherData))
  }

  useEffect(() => {
    if (role === "teacher") {
      history.push("/tutor/profile")
    }
  }, [role])

  return (
    <Box>
      <Logo _fontSize={"3rem"} _mt={8}/>
      <FormControl id="fullname" isRequired mt={"40px"} isInvalid={errorFullname !== ""}>
        <FormLabel fontSize={16} fontWeight={600}>Fullname</FormLabel>
        <Input type="text" autoFocus={true} placeholder="Enter your fullname" w={"clamp(150px, 80vw, 400px)"} required
               value={fullname} min={3} max={30}
               onChange={(e) => handleFullname(e.target.value)}/>
        <FormErrorMessage w={"clamp(150px, 80vw, 400px)"}>{errorFullname}</FormErrorMessage>
      </FormControl>
      <FormControl id="email" isRequired mt={"20px"} isInvalid={errorEmail !== ""}>
        <FormLabel fontSize={16} fontWeight={600}>Email Address</FormLabel>
        <Input type="email" placeholder="Enter your email" w={"clamp(150px, 80vw, 400px)"} required
               value={email}
               onChange={(e) => handleEmail(e.target.value)}/>
        <FormErrorMessage w={"clamp(150px, 80vw, 400px)"}>{errorEmail}</FormErrorMessage>
      </FormControl>
      <FormControl id="username" isRequired mt={"20px"} isInvalid={errorUsername !== ""}>
        <FormLabel fontSize={16}
                   fontWeight={600}>Username</FormLabel>{/* use ajax to check if username exists in the database*/}
        <Input type="text" placeholder="Enter a unique username" w={"clamp(150px, 80vw, 400px)"}
               required
               value={username}
               onChange={(e) => handleUsername(e.target.value)}/>
        <FormErrorMessage w={"clamp(150px, 80vw, 400px)"}>{errorUsername}</FormErrorMessage>
      </FormControl>
      <FormControl id="password" isRequired m={"20px 0"} isInvalid={errorPassword !== ""}>
        <FormLabel fontSize={16} fontWeight={600} textTransform={"capitalize"}>Password
        </FormLabel>
        <Input id={"pwd"} type={`${eyeStatus ? "password" : "text"}`} placeholder="Enter your password" value={password}
               required
               w={"clamp(150px, 80vw, 400px)"} pos={"relative"}
               onChange={(e) => handlePassword(e.target.value)}/>
        <Box pos={"absolute"} zIndex={"docked"} top={"40px"} right={"15px"} cursor={"pointer"}>
          <i className={`${eyeStatus ? "fas fa-eye" : "fas fa-eye-slash"}`} onClick={() => revealPassword()}/>
        </Box>
        <FormErrorMessage w={"clamp(150px, 80vw, 400px)"}>{errorPassword}</FormErrorMessage>
      </FormControl>
      <Button type={"submit"} size="lg" textTransform={"capitalize"} fontSize={16} bgColor={"brand.darkGreen"}
              color={"brand.white"}
              display={"block"}
              w={"clamp(150px, 80vw, 400px)"} onClick={(e) => submitForm(e)}>sign up
      </Button>
      <br/>
      <Box textAlign={"center"}>
        <Link as={NavLink} to={"/auth/tutor/login"} textAlign={"center"} fontSize={14} color={"brand.grey"}>
          Already have any account? Login
        </Link>
      </Box>
    </Box>
  );
}

export default TeacherRegister;